var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagZimbabwe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4686 9.16271C29.6557 7.44558 28.5462 5.89665 27.2062 4.58133L16 3.47827L4.79374 4.5814C4.75799 4.61646 4.72312 4.65233 4.68774 4.68777L9.16274 9.16277L16 9.37158L30.4686 9.16271Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68756 27.3125C4.74644 27.3714 4.80519 27.4304 4.86494 27.4884L16 28.5219L27.1349 27.4884C28.4887 26.1759 29.6117 24.6268 30.4361 22.907L9.73906 22.261C7.95825 24.0419 5.90425 26.0957 4.68756 27.3125Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8413 13.744L13.2178 13.2173L16.0004 15.9999C15.1762 16.8241 13.9458 18.0545 13.2178 18.7825L31.8315 18.3254C31.9421 17.5661 32.0004 16.7898 32.0004 15.9999C32.0004 15.234 31.9454 14.4812 31.8413 13.744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.6358 0 7.68039 1.74813 4.79376 4.58138H27.2063C24.3196 1.74813 20.3643 0 16 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7437 13.744H31.8405C31.6122 12.1265 31.1424 10.5869 30.4682 9.1626H9.16232L13.7437 13.744Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09277 22.9068H30.4358C31.1179 21.4836 31.5951 19.9438 31.8308 18.3254H13.6741C11.9 20.0996 10.3963 21.6033 9.09277 22.9068Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0001C20.3284 32.0001 24.2547 30.2806 27.1349 27.4883H4.86505C7.7453 30.2806 11.6716 32.0001 16 32.0001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71371 3.74585C5.35802 4.04472 5.01484 4.35804 4.68652 4.68622L16.0003 16L4.68652 27.3137C5.01477 27.642 5.35802 27.9552 5.71371 28.2541L17.9678 16L5.71371 3.74585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43281 11.8262L7.46875 15.0147H10.8216L8.10919 16.9854L9.14519 20.174L6.43281 18.2034L3.72038 20.174L4.7565 16.9854L2.04419 15.0147H5.39681L6.43281 11.8262Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28213 16.2609L6.58226 15.3044C6.58226 15.3044 6.38276 13.4329 6.3707 13.3695C6.27907 12.8868 5.85488 12.5217 5.34551 12.5217C4.76926 12.5217 4.30201 12.9889 4.30201 13.5652C4.30201 13.6608 4.31595 13.7529 4.34001 13.8409L3.58301 14.6029H4.92901C4.92901 16 3.88651 16 3.88651 17.3913L4.46482 18.7826H7.94307L8.52282 17.3913H8.52257C8.58063 17.2578 8.61588 17.1201 8.63045 16.9825C9.1302 16.7804 9.28213 16.2609 9.28213 16.2609Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagZimbabwe);
export default __webpack_public_path__ + "static/media/flag_zimbabwe.b4a4a426ce71c0a9968c663085d8922d.svg";
export { ForwardRef as ReactComponent };